module.exports = __webpack_public_path__ + "img/chart.314c5a6.png";